import { useTranslation } from 'react-i18next'

export default function Footer() {
  const { t } = useTranslation()
  return (
    <footer className='ml-auto text-right p-8 mt-32 text-sm'>
      <p>
        {t('Footer.made-with')}💚{t('Footer.using')}
        <a href='https://react.dev/' target='_blank' rel='noreferrer'>
          React
        </a>
        {t('Footer.and')}
        <a href='https://tailwindcss.com/' target='_blank' rel='noreferrer'>
          Tailwind
        </a>
      </p>
      <p>© {new Date().getFullYear()}</p>
    </footer>
  )
}
